import { createSelector } from 'reselect';

const selectProgressBar = (state) => state.get('progressBar');

const makeSelectProgressBarStatus = () =>
  createSelector(selectProgressBar, (state) => state.get('loading'));

export { makeSelectProgressBarStatus };



// WEBPACK FOOTER //
// ./app/containers/ProgressBar/selectors.js